import { PesticideMapPolygonInfo } from "entities/pesticideMap";
import { FC, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
import { PesticideMapPolygonModalHead, PesticideMapPolygonModalRow, PesticideMapPolygonModalWrapper } from "./styles";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { CloseIcon } from "shared/ui/icons";
import { format } from "date-fns";
import { pluralize } from "shared/helpers";

type PesticideMapPolygonModalProps = {
  isOpen: boolean;
  position: number[] | null;
  activePolygon: PesticideMapPolygonInfo | null;
  onClose: () => void;
}

export const PesticideMapPolygonModal: FC<PesticideMapPolygonModalProps> = ({
  isOpen,
  position,
  activePolygon,
  onClose
}) => {

  const ref = useRef<HTMLDivElement | null>(null);

  const topMemoized = useMemo(() => {
    const top = position?.[1];

    if (!top||!ref.current) return '50%';

    let topAnswer = top;

    const windowHeight = window.innerHeight;
    const wrapperHeight = ref.current.getBoundingClientRect().height;

    while (windowHeight - (wrapperHeight + topAnswer + 20) < 20) {
      topAnswer--
    }

    return `${topAnswer / 16}rem`;
  }, [position, ref, isOpen])

  const leftMemoized = useMemo(() => {
    const left = position?.[0];

    if (!left||!ref.current) return '50%';

    const windowWidth = window.innerWidth;

    let leftAnswer = left;

    while (windowWidth - (leftAnswer + 618) < 20) {
      leftAnswer--;
    }

    return `${leftAnswer / 16}rem`
  }, [position, ref, isOpen])

  const nameOfPA = useMemo(() => {
    if (!activePolygon) return '';

    return activePolygon.patAllList?.map(el => el.name).join(', ')
  }, [activePolygon])

  return createPortal(
    <PesticideMapPolygonModalWrapper
      ref={ref}
      $isActive={isOpen}
      $top={topMemoized}
      $left={leftMemoized}
    >
      <PesticideMapPolygonModalHead>
        <h3>Информация о применении пестицидов</h3>
        <Button 
          iconPrefix={<CloseIcon />}
          variant='secondary'
          colorScheme='neutral'
          size="m"
          onClick={onClose}
        />
      </PesticideMapPolygonModalHead>

      {activePolygon?.name && 
        <PesticideMapPolygonModalRow>
          <span>Распространитель</span>
          <p>{activePolygon.name}</p>
        </PesticideMapPolygonModalRow>
      }

      {activePolygon?.subName && 
      <PesticideMapPolygonModalRow>
        <span>Регион распространения:</span>
        <p>{activePolygon.subName}</p>
      </PesticideMapPolygonModalRow>
      }

      {(activePolygon?.centerX&&activePolygon?.centerY) && 
      <PesticideMapPolygonModalRow>
        <span>Координаты:</span>
        <p>{activePolygon.centerX}, {activePolygon.centerY}</p>
      </PesticideMapPolygonModalRow>
      }

      {activePolygon?.cadNum && 
      <PesticideMapPolygonModalRow>
        <span>Кадастровый номер:</span>
        <p>{activePolygon.cadNum}</p>
      </PesticideMapPolygonModalRow>
      }

      {activePolygon?.area && 
      <PesticideMapPolygonModalRow>
        <span>Площадь обработки:</span>
        <p>{activePolygon.area}</p>
      </PesticideMapPolygonModalRow>
      }

      {activePolygon?.startPlanDate && 
      <PesticideMapPolygonModalRow>
        <span>Начало применения:</span>
        <p>{format(activePolygon.startPlanDate, 'dd.MM.yyyy')}</p>
      </PesticideMapPolygonModalRow>
      }

      {activePolygon?.finishPlanDate && 
      <PesticideMapPolygonModalRow>
        <span>Окончание применения:</span>
        <p>{format(activePolygon.finishPlanDate, 'dd.MM.yyyy')}</p>
      </PesticideMapPolygonModalRow>
      }

      {nameOfPA && 
      <PesticideMapPolygonModalRow>
        <span>Наименование ПА:</span>
        <p>{nameOfPA}</p>
      </PesticideMapPolygonModalRow>
      }

      {activePolygon?.timeHandleMax && 
      <PesticideMapPolygonModalRow>
        <span>Ограничение ручных работ:</span>
        <p>{activePolygon.timeHandleMax} {pluralize(Number(activePolygon.timeHandleMax), 'день', 'дня', 'дней')} после обработки</p>
      </PesticideMapPolygonModalRow>
      }

      {activePolygon?.timeWorkMax && 
      <PesticideMapPolygonModalRow>
        <span>Ограничение ручных работ:</span>
        <p>{activePolygon.timeWorkMax} {pluralize(Number(activePolygon.timeWorkMax), 'день', 'дня', 'дней')} после обработки</p>
      </PesticideMapPolygonModalRow>
      }
    </PesticideMapPolygonModalWrapper>,
    document.body
  )
}